import React, { FC, ReactNode, useCallback, useLayoutEffect } from 'react';
import {
  TrialLockoutProvider as SharedTrialLockoutProvider,
  startTrialLockoutBackgroundPreload,
} from '@discover-frontend/components';

import { TrialLockoutModal } from '../components/trial-lockout-modal';
import { isTrialUserFromToken } from 'src/utils/AuthHelperMethods';

type AccountsTrialLockoutProviderProps = {
  children: ReactNode;
  decodedToken?: Record<string, unknown> | null;
};

/** Accounts adapter — wires shared lockout provider to auth + Redux toasts. */
export const TrialLockoutProvider: FC<AccountsTrialLockoutProviderProps> = ({
  children,
  decodedToken,
}) => {
  const isTrialUser = useCallback(
    () => isTrialUserFromToken(decodedToken),
    [decodedToken]
  );

  useLayoutEffect(() => {
    if (isTrialUser()) startTrialLockoutBackgroundPreload();
  }, [isTrialUser]);

  return (
    <SharedTrialLockoutProvider
      isTrialUser={isTrialUser}
      renderLockoutModal={() => <TrialLockoutModal />}
    >
      {children}
    </SharedTrialLockoutProvider>
  );
};
